/**
 * 
 * key
 * 
 */


const key = 'c3RhdGU='

export default key 